import React from 'react';

const DemoEditor = ({ formData, handleInputChange }) => {
  const testLink = () => {
    if (formData.demoUrl) {
      window.open(formData.demoUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="form-section">
      <h3>Demo Link</h3>
      <div className="form-row">
        <div className="form-group" style={{ flex: 1 }}>
          <label>Demo URL</label>
          <div className="image-upload-row">
            <input
              type="url"
              name="demoUrl"
              className="form-control"
              value={formData.demoUrl || ''}
              onChange={handleInputChange}
              placeholder="https://demo.example.com"
            />
            <button
              type="button"
              className="btn btn-sm btn-outline"
              disabled={!formData.demoUrl}
              onClick={testLink}
            >
              Test Link
            </button>
          </div>
          <small className="text-muted">
            The demo button on the product detail page will link to this URL when both
            "Show Demo Link" (Visibility) and "Demo" (Feature Flags) are enabled.
          </small>
        </div>
      </div>
    </div>
  );
};

export default DemoEditor;
